// Selectors
import {getStyle} from '~/selectors/CatalogSelectors';
import {getSelectedProductCurrentColor} from '~/selectors/ProductSelectors';
// Action Types
import AnalyticsTypes from '~/constants/types/AnalyticsTypes';
import ProductTypes from '~/constants/types/ProductTypes';
// Utils
import {
  getStylePrimaryCategoryDescription,
  getStylePrimaryColorFromNextColors
} from './utils';

const Product = {
  startFromWelcome: () => ({
    event: 'lab_changeproduct_start',
    source: 'welcome'
  }),
  startFromTray: () => ({
    event: 'lab_changeproduct_start',
    source: 'tray'
  }),
  startFromMobileProductDetails: () => ({
    event: 'lab_changeproduct_start',
    source: 'mobile_product_details'
  }),
  swap: (state, {payload}) => {
    if (payload?.isInitialLabLoad) return null;
    const style = getStyle(state, {
      styleId: payload?.nextStyleId
    });
    return {
      event: 'lab_changeproduct_complete',
      product_style_id: style?.id,
      product_style_name: style?.name,
      product_color: getStylePrimaryColorFromNextColors(
        style,
        payload?.nextColorIds
      ),
      product_category: getStylePrimaryCategoryDescription(style),
      source: 'product_catalog_modal'
    };
  },
  changeColorStart: (_, {payload}) => {
    const possibleSources = {
      'side bar': 'menu',
      'bottom bar': 'tray'
    };
    return {
      event: 'lab_productcolor_start',
      source: possibleSources[payload?.source] || payload?.source
    };
  },
  changeColorClose: (state, {payload}) => {
    if (payload !== 'close') return null;
    const currentColor = getSelectedProductCurrentColor(state);
    return {
      event: 'lab_productcolor_complete',
      product_color: currentColor.name
    };
  },
  toggleSinglesFilter: (_, {payload}) => {
    return {
      event: 'lab_product_singles_filter',
      quantity_filter: payload?.quantityFilter,
      source: payload?.source
    };
  }
};

const ProductEvents = {
  [AnalyticsTypes.PRODUCT_WELCOME]: Product.startFromWelcome,
  [AnalyticsTypes.PRODUCT_SUMMARY_TAG]: Product.startFromTray,
  [AnalyticsTypes.CHANGE_PRODUCT_START]: Product.startFromMobileProductDetails,
  [ProductTypes.SWAP_PRODUCT]: Product.swap,
  [AnalyticsTypes.CHANGE_PRODUCT_COLOR_START]: Product.changeColorStart,
  [AnalyticsTypes.PRODUCT_COLOR]: Product.changeColorClose,
  [AnalyticsTypes.PRODUCT_COLOR_TOGGLE_CHANGED]: Product.toggleSinglesFilter
};

export default ProductEvents;
